/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-list/bulblist
 */

import { Plugin } from 'ckeditor5';

import BulbListUi from './bulblistui';

/**
 * The general dropdown list plugin.
 *
 * @extends Plugin
 */
export default class BulbList extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbListUi] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbList' as const;
  }
}
